module.exports = __webpack_public_path__ + "img/2025-02-13e_1.67a245a8.jpg";